export default __webpack_public_path__ + "static/media/svg-8.97119435.svg";